export function getLangData(moduleId) {
    return Subscribers.getMultiLangData(moduleId) || {
        json: {},
        intl: null
    }
}